import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Card, Col, Row, Typography } from 'antd';

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';

const { Paragraph, Title } = Typography;

const platformIds = [
  'platforms-nasdaq',
  'platforms-nyse',
  'platforms-exetra',
  'platforms-binance',
  'platforms-okx',
  'platforms-bybit',
];

const PlatformSection = () => {
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__platforms" id="integration">
      <div className="home-page__section-frame">
        <div>
          <Title level={2}>
            <FormattedMessage id={homeMessageId('integration.title')} />
          </Title>
          <Paragraph>
            <FormattedMessage id={homeMessageId('integration.text')} />
          </Paragraph>
        </div>
        <Row className="home-page__platform-grid" gutter={[33, 33]}>
          {platformIds.map((id) => (
            <Col xs={24} sm={12} lg={8} xl={4} key={id}>
              <Card className="home-page__platform-card" variant="borderless">
                <AiIcon name={id} />
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default PlatformSection;
